/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalTerms1 } from './AdditionalTerms1';
import {
    AdditionalTerms1FromJSON,
    AdditionalTerms1FromJSONTyped,
    AdditionalTerms1ToJSON,
} from './AdditionalTerms1';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage1 } from './BuyerAgentCommissionPercentage1';
import {
    BuyerAgentCommissionPercentage1FromJSON,
    BuyerAgentCommissionPercentage1FromJSONTyped,
    BuyerAgentCommissionPercentage1ToJSON,
} from './BuyerAgentCommissionPercentage1';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage1 } from './ConcessionsPercentage1';
import {
    ConcessionsPercentage1FromJSON,
    ConcessionsPercentage1FromJSONTyped,
    ConcessionsPercentage1ToJSON,
} from './ConcessionsPercentage1';
import type { CreateOfferRequestSource } from './CreateOfferRequestSource';
import {
    CreateOfferRequestSourceFromJSON,
    CreateOfferRequestSourceFromJSONTyped,
    CreateOfferRequestSourceToJSON,
} from './CreateOfferRequestSource';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingType } from './FinancingType';
import {
    FinancingTypeFromJSON,
    FinancingTypeFromJSONTyped,
    FinancingTypeToJSON,
} from './FinancingType';
import type { TermsStatus } from './TermsStatus';
import {
    TermsStatusFromJSON,
    TermsStatusFromJSONTyped,
    TermsStatusToJSON,
} from './TermsStatus';

/**
 * 
 * @export
 * @interface CreateOfferTermsRequest
 */
export interface CreateOfferTermsRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateOfferTermsRequest
     */
    offerPrice: number;
    /**
     * 
     * @type {Array<FinancingType>}
     * @memberof CreateOfferTermsRequest
     */
    financingTypes: Array<FinancingType>;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferTermsRequest
     */
    earnestMoneyDeposit: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferTermsRequest
     */
    dueDiligencePeriodDays: number;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof CreateOfferTermsRequest
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof CreateOfferTermsRequest
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferTermsRequest
     */
    closingDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferTermsRequest
     */
    titleCompany: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfferTermsRequest
     */
    requestSellerConcessions: boolean;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof CreateOfferTermsRequest
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof CreateOfferTermsRequest
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage1}
     * @memberof CreateOfferTermsRequest
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage1;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof CreateOfferTermsRequest
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof CreateOfferTermsRequest
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof CreateOfferTermsRequest
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage1}
     * @memberof CreateOfferTermsRequest
     */
    concessionsPercentage?: ConcessionsPercentage1;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferTermsRequest
     */
    submissionAdditionalTerms?: string;
    /**
     * 
     * @type {AdditionalTerms1}
     * @memberof CreateOfferTermsRequest
     */
    additionalTerms?: AdditionalTerms1;
    /**
     * 
     * @type {CreateOfferRequestSource}
     * @memberof CreateOfferTermsRequest
     */
    source?: CreateOfferRequestSource;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfferTermsRequest
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferTermsRequest
     */
    downPayment?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferTermsRequest
     */
    additionalComments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfferTermsRequest
     */
    hasDocuments?: boolean;
    /**
     * 
     * @type {TermsStatus}
     * @memberof CreateOfferTermsRequest
     */
    termsStatus?: TermsStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferTermsRequest
     */
    draftTermId?: string;
}

/**
 * Check if a given object implements the CreateOfferTermsRequest interface.
 */
export function instanceOfCreateOfferTermsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "offerPrice" in value;
    isInstance = isInstance && "financingTypes" in value;
    isInstance = isInstance && "earnestMoneyDeposit" in value;
    isInstance = isInstance && "dueDiligencePeriodDays" in value;
    isInstance = isInstance && "closingDate" in value;
    isInstance = isInstance && "titleCompany" in value;
    isInstance = isInstance && "requestSellerConcessions" in value;

    return isInstance;
}

export function CreateOfferTermsRequestFromJSON(json: any): CreateOfferTermsRequest {
    return CreateOfferTermsRequestFromJSONTyped(json, false);
}

export function CreateOfferTermsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOfferTermsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerPrice': json['offer_price'],
        'financingTypes': ((json['financing_types'] as Array<any>).map(FinancingTypeFromJSON)),
        'earnestMoneyDeposit': json['earnest_money_deposit'],
        'dueDiligencePeriodDays': json['due_diligence_period_days'],
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'closingDate': json['closing_date'],
        'titleCompany': json['title_company'],
        'requestSellerConcessions': json['request_seller_concessions'],
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentage1FromJSON(json['buyer_agent_commission_percentage']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentage1FromJSON(json['concessions_percentage']),
        'submissionAdditionalTerms': !exists(json, 'submission_additional_terms') ? undefined : json['submission_additional_terms'],
        'additionalTerms': !exists(json, 'additional_terms') ? undefined : AdditionalTerms1FromJSON(json['additional_terms']),
        'source': !exists(json, 'source') ? undefined : CreateOfferRequestSourceFromJSON(json['source']),
        'sendEmail': !exists(json, 'send_email') ? undefined : json['send_email'],
        'downPayment': !exists(json, 'down_payment') ? undefined : json['down_payment'],
        'additionalComments': !exists(json, 'additional_comments') ? undefined : json['additional_comments'],
        'hasDocuments': !exists(json, 'has_documents') ? undefined : json['has_documents'],
        'termsStatus': !exists(json, 'terms_status') ? undefined : TermsStatusFromJSON(json['terms_status']),
        'draftTermId': !exists(json, 'draft_term_id') ? undefined : json['draft_term_id'],
    };
}

export function CreateOfferTermsRequestToJSON(value?: CreateOfferTermsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offer_price': value.offerPrice,
        'financing_types': ((value.financingTypes as Array<any>).map(FinancingTypeToJSON)),
        'earnest_money_deposit': value.earnestMoneyDeposit,
        'due_diligence_period_days': value.dueDiligencePeriodDays,
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'closing_date': value.closingDate,
        'title_company': value.titleCompany,
        'request_seller_concessions': value.requestSellerConcessions,
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentage1ToJSON(value.buyerAgentCommissionPercentage),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentage1ToJSON(value.concessionsPercentage),
        'submission_additional_terms': value.submissionAdditionalTerms,
        'additional_terms': AdditionalTerms1ToJSON(value.additionalTerms),
        'source': CreateOfferRequestSourceToJSON(value.source),
        'send_email': value.sendEmail,
        'down_payment': value.downPayment,
        'additional_comments': value.additionalComments,
        'has_documents': value.hasDocuments,
        'terms_status': TermsStatusToJSON(value.termsStatus),
        'draft_term_id': value.draftTermId,
    };
}

